<p>veteran-work-shift-kind-list works!</p>
